module.exports = __webpack_public_path__ + "static/d4bl-99b97a143ae22a9f066ab12cc0092e85.png";